import { MarkerF } from "@react-google-maps/api";

const MarkerFicha = ({ marker, draggable, setPlace }) => {
    const image = "https://media.grupoguia.mx/assets/apps-icons/marker.webp";

    const handleDrag = (e) => {
        if (draggable) {
            const geocoder = new window.google.maps.Geocoder();
            const latlng = { lat: e.latLng.lat(), lng: e.latLng.lng() };

            geocoder.geocode({ location: latlng }, (results, status) => {
                if (status === "OK" && results[0]) {
                    setPlace(results[0]);
                } else {
                    console.error("Geocoding failed:", status);
                }
            });
        }
    };
    return (
        <>
            <MarkerF
                icon={{
                    url: image,
                    scaledSize: {
                        width: 30,
                        height: 30,
                    },
                    fillOpacity: 0,
                }}
                title={marker.title}
                position={marker.position}
                draggable={draggable ? draggable : false}
                onDragEnd={(e) => {
                    handleDrag(e);
                }}
            />
        </>
    );
};

export default MarkerFicha;
